import React, { useEffect, useState } from 'react';
import MessageTotalCountPublish from '../messageTotalCountPublish';
import mcsApi from '@/apis/generic/mcs';
import ComponentLog from '@/components/component-log';
import { Badge } from '@drip/drip-design';
import { withRouter } from 'react-router-dom';
import './index.less';

function renderNumber(number: number) {
  if (!number) return '';
  if (number > 99) return '(99)';
  return `(${number})`;
}

function PageTitle(props: any) {
  const { subscribe, remove } = MessageTotalCountPublish();
  const [total, setTotal] = useState(0);
  const [showBadge, setShowBadge] = useState(true);

  useEffect(() => {
    setShowBadge(props.location.pathname !== '/all-about-me/activity-message-center');
  }, [props.location.pathname]);

  useEffect(() => {
    subscribe((num: number) => {
      setTotal(num);
    });

    return () => {
      remove((num: number) => {
        setTotal(num);
      });
    };
    // eslint-disable-next-line
  }, [subscribe, remove]);

  useEffect(() => {
    mcsApi.genericMessageTotalMessageNum().then(({ ret, data, msg }: any = {}) => {
      if (ret === '0') {
        setTotal(data?.data || 0);
      }
    });
  }, []);

  return (
    <ComponentLog clstag="yx_common_hddt|activitynews_entrance">
      <span>
        活动动态
        <span>{renderNumber(total)}</span>
      </span>
    </ComponentLog>
  );
}

export default withRouter(PageTitle);
